import axios from 'axios';

const instance = axios.create({
    // baseURL: 'http://construcaosocialista.web15f59.uni5.net/api/public/api/',
    baseURL: 'https://construcaosocialista.com.br/api/public/api/',
});

export default instance;